export default __webpack_public_path__ + "media/MeetRovoBanner.2a4b39795da6c528aaff4ba6ab27efd1.svg";